import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTheme } from '../../theme';

const navItems = [
  { to: '/search-tags', label: 'SEARCH' },
  { to: '/make-a-tag',  label: 'FILE A TAG' },
  { to: '/guidelines',  label: 'GUIDELINES' },
];

export default function Nav({ token, handleLogOut }) {
  const { p, d, fonts } = useTheme();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const linkStyle = (isActive) => ({
    color: isActive ? p.accent : p.text,
    borderBottom: isActive ? `1px solid ${p.accent}` : '1px solid transparent',
    paddingBottom: 2,
    cursor: 'pointer',
    textDecoration: 'none',
  });

  return (
    <nav style={{
      padding: `18px ${d.pad}px`,
      borderBottom: `1px solid ${p.border}`,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontFamily: fonts.mono,
      fontSize: 13,
      position: 'relative',
    }}>
      {/* brand */}
      <NavLink to="/" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none' }}>
        <span style={{
          width: 8, height: 8, background: p.accent, display: 'inline-block',
          boxShadow: `0 0 12px ${p.accent}`,
        }} />
        <span style={{ color: p.textHi, letterSpacing: '-.005em', fontSize: 15, fontWeight: 500 }}>usertags</span>
        <span style={{ color: p.textFaint, fontSize: 11, letterSpacing: '.08em' }}>/ARCHIVAL INDEX</span>
      </NavLink>

      {/* desktop nav */}
      <div style={{ display: 'flex', gap: 28, fontSize: 12, letterSpacing: '.04em', alignItems: 'center' }}
        className="nav-desktop">
        {navItems.map(item => (
          <NavLink key={item.to} to={item.to} style={({ isActive }) => linkStyle(isActive)}>
            {item.label}
          </NavLink>
        ))}

        {token ? (
          <button
            onClick={() => { handleLogOut(); navigate('/'); }}
            style={{
              padding: '7px 16px',
              border: `1px solid ${p.borderHi}`,
              color: p.text,
              background: 'transparent',
              fontFamily: fonts.mono,
              fontSize: 12,
              letterSpacing: '.04em',
              cursor: 'pointer',
            }}
          >
            LOG OUT
          </button>
        ) : (
          <>
            <NavLink to="/login" style={({ isActive }) => ({
              padding: '7px 16px',
              border: `1px solid ${isActive ? p.accent : p.borderHi}`,
              color: isActive ? p.accent : p.textHi,
              textDecoration: 'none',
              fontFamily: fonts.mono,
              fontSize: 12,
              letterSpacing: '.04em',
            })}>
              SIGN IN ↵
            </NavLink>
            <NavLink to="/signup" style={{
              padding: '7px 16px',
              background: p.accent,
              color: p.bg,
              fontWeight: 500,
              textDecoration: 'none',
              fontFamily: fonts.mono,
              fontSize: 12,
              letterSpacing: '.04em',
            }}>
              SIGN UP →
            </NavLink>
          </>
        )}
      </div>

      {/* mobile hamburger */}
      <button
        className="nav-mobile-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
        style={{
          display: 'none',
          background: 'transparent',
          border: `1px solid ${p.borderHi}`,
          color: p.textHi,
          fontFamily: fonts.mono,
          fontSize: 18,
          padding: '4px 10px',
          cursor: 'pointer',
        }}
      >
        {menuOpen ? '✕' : '☰'}
      </button>

      {/* mobile dropdown */}
      {menuOpen && (
        <div
          className="nav-mobile-menu"
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            background: p.bgPanel,
            borderBottom: `1px solid ${p.border}`,
            padding: `${d.gap}px ${d.pad}px`,
            display: 'flex',
            flexDirection: 'column',
            gap: 20,
            zIndex: 100,
          }}
        >
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setMenuOpen(false)}
              style={({ isActive }) => ({
                ...linkStyle(isActive),
                fontSize: 14,
              })}
            >
              {item.label}
            </NavLink>
          ))}
          {token ? (
            <button
              onClick={() => { handleLogOut(); navigate('/'); setMenuOpen(false); }}
              style={{
                background: 'transparent',
                border: `1px solid ${p.borderHi}`,
                color: p.text,
                fontFamily: fonts.mono,
                fontSize: 14,
                padding: '10px 16px',
                cursor: 'pointer',
                textAlign: 'left',
              }}
            >
              LOG OUT
            </button>
          ) : (
            <>
              <NavLink to="/login" onClick={() => setMenuOpen(false)} style={{
                color: p.accent, textDecoration: 'none', fontSize: 14,
              }}>
                SIGN IN ↵
              </NavLink>
              <NavLink to="/signup" onClick={() => setMenuOpen(false)} style={{
                padding: '10px 16px',
                background: p.accent,
                color: p.bg,
                fontWeight: 500,
                textDecoration: 'none',
                fontSize: 14,
                textAlign: 'center',
              }}>
                SIGN UP →
              </NavLink>
            </>
          )}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .nav-desktop { display: none !important; }
          .nav-mobile-toggle { display: block !important; }
        }
        @media (min-width: 769px) {
          .nav-mobile-menu { display: none !important; }
        }
      `}</style>
    </nav>
  );
}
